import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addLeaveAllocation = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Leave Allocation',
    body
  );
  return data;
});
export const updateLeaveAllocation = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Leave Allocation/${id}`,
    body
  );
  return data;
});

export const getLeaveAllocation = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Leave Allocation?fields=["name","docstatus","employee_name","total_leaves_allocated"]&limit_page_length=10&limit_start=0&order_by=creation desc'
  );
  return data;
});
export const deleteLeaveAllocation = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Leave Allocation/${record}`
  );
  return data;
});
export const getLeaveAllocationDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Leave Allocation/${id}`
  );
  return data;
});
